(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/my-information/transcript-panel/components/top-bottom-border.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/my-information/transcript-panel/components/top-bottom-border.js');
'use strict';

const TopBottomBorder = _ref => {
  let {
    children
  } = _ref;
  return React.createElement("p", {
    className: "u-border-top-1 u-border-bottom-1 border-navy padding-v-1"
  }, children);
};
svs.myProfile.react.pages.myInformation.transcript.TopBottomBorder = TopBottomBorder;

 })(window);